<template>
  <div class="demo-app">
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'App',
  setup () {
    return {}
  },
})
</script>
<style lang="scss" scoped>
.demo-app {
  width: 100%;
  height: 100%;
}
</style>

<style lang="scss">
#demo-app {
  width: 100%;
  height: 100%
}
</style>
